import React from 'react';
import { Link } from 'react-router-dom';
import './school-login.css';
import './school-portal.css';

/* Landing for the School portal nav link. Two tiles: kid (PIN flow) and
 * teacher / school admin (email + password). Kept tiny on purpose —
 * the real flows live one tap away. */
export default function SchoolPortal() {
  return (
    <div className="sl-page">
      <div className="sl-bg" aria-hidden="true" />
      <Link to="/" className="sl-floating-back">&#8592; Homepage</Link>

      <div className="sl-shell sp-shell">
        <div className="sl-eyebrow">School portal</div>
        <h1 className="sl-h1 sp-h1">Who's signing in?</h1>
        <p className="sl-sub sp-sub">Pick the option that fits you.</p>

        <div className="sp-tiles">
          <Link to="/school-login" className="sp-tile">
            <span className="sp-tile-emoji" aria-hidden="true">🎒</span>
            <span className="sp-tile-name">I'm a student</span>
            <span className="sp-tile-sub">School code → name → PIN</span>
          </Link>
          <Link to="/login?role=staff" className="sp-tile">
            <span className="sp-tile-emoji" aria-hidden="true">📋</span>
            <span className="sp-tile-name">Teacher or school admin</span>
            <span className="sp-tile-sub">Email and password</span>
          </Link>
        </div>

        <p className="sl-tiny sp-tiny">
          New here? <Link to="/school-join" className="sl-link">Join DeenLit as a school &rarr;</Link>
        </p>
        <p className="sl-tiny sp-tiny" style={{ marginTop: 4 }}>
          Parent account? <Link to="/login" className="sl-link">Parent sign in &rarr;</Link>
        </p>
      </div>
    </div>
  );
}
